import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import core from "src/reducers/reducer_core";
import userManagement from "src/reducers/reducer_user_management";
import roleManagement from "src/reducers/reducer_role_management";
import myProfile from "src/reducers/reducer_my_profile";
import forgotPassword from "src/reducers/reducer_forgot_password";
import customerManagement from "src/reducers/reducer_customer_management";
import retailerManagement from "src/reducers/reducer_retailer_management";
import creditPackages from "src/reducers/reducer_credit_packages";
import cardManagement from "src/reducers/reducer_card_management";
import productManagement from "src/reducers/reducer_product_management";
import redemptionProduct from "src/reducers/reducer_redemption_product";
import treasureBox from "src/reducers/reducer_treasure_box";
import treasureBoxPlays from "src/reducers/reducer_treasure_box_plays";
import bankTransfers from "src/reducers/reducer_bank_transfers";
import orderManagement from "src/reducers/reducer_order_management";
import redemptionOrder from "src/reducers/reducer_redemption_order";
import campaignPrizes from "src/reducers/reducer_campaign_prizes";
import customerCampaigns from "src/reducers/reducer_customer_campaigns";
import campaignPrizeOrders from "src/reducers/reducer_campaign_prize_orders";
import salesReport from "src/reducers/reducer_sales_report";
import transactionHistory from "src/reducers/reducer_transaction_history";
import prizeDistributionRules from "src/reducers/reducer_prize_distribution_rules";
import treasureBoxSettings from "src/reducers/reducer_treasure_box_settings";
import retailerCardCustomers from "src/reducers/reducer_retailer_card_customers";
import customerPurchases from "src/reducers/reducer_customer_purchases";
import bigPrizeAssignments from "src/reducers/reducer_big_prize_assignments";
import referralSettings from "src/reducers/reducer_referral_settings";
import referralManagement from "src/reducers/reducer_referral_management";
import stockSettings from "src/reducers/reducer_stock_settings";
import supportTickets from "src/reducers/reducer_support_tickets";

const appReducer = combineReducers({
    core,
    userManagement,
    roleManagement,
    myProfile,
    forgotPassword,
    customerManagement,
    retailerManagement,
    creditPackages,
    cardManagement,
    productManagement,
    redemptionProduct,
    treasureBox,
    treasureBoxPlays,
    bankTransfers,
    orderManagement,
    redemptionOrder,
    campaignPrizes,
    customerCampaigns,
    campaignPrizeOrders,
    salesReport,
    transactionHistory,
    prizeDistributionRules,
    treasureBoxSettings,
    retailerCardCustomers,
    customerPurchases,
    bigPrizeAssignments,
    referralSettings,
    referralManagement,
    stockSettings,
    supportTickets,
});

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        Object.keys(state).forEach((key) => {
            storage.removeItem(`persist:${key}`);
        });
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
